import axios from 'axios'
import store from '@/store/index.js'
import router from '@/router'

var baseApiUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:5501' : process.env.VUE_APP_API_URL
//var baseApiUrl = 'https://tradeapi.algoplus.com.br'

const http = axios.create({
  baseURL: baseApiUrl
});

http.interceptors.request.use(
  request => {
    request.headers['api-key'] = localStorage.getItem('api-key')
    request.headers['tenantid'] = store.getters.WorkTenant?.id
    return request
  },
  error => Promise.reject(error)
)

http.interceptors.response.use(
  (response) => { 
    return response 
  }, 
  async function (error) {
    if (!error.response) 
    {
      router.push('/authorize')
    }
    else 
    {
      if (error.response.status === 401) {
        store.commit('Unauthorized')
        router.push('/authorize')
      }
      if (error.response.status === 403) {
        alert('Você não permissão para acessar essa função!')
      }    
    }
    return Promise.reject(error)
  })

export default http
